import constants from "../../../config/constants";
import  getHelper from "../../../helper.js";
<!-- Helpers -->
$ function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
$ const cb_PUBLISHABLE_KEY = constants.CB_PUBLISHABLE_KEY;
$ const cb_site = constants.SITE;
$ const BASE_URL = constants.BASE_URL;
$ const ENV = constants.ENV;
<preauth_layout page="setup" setup=true whopBase=true PH_KEY=input.PH_KEY distinctId=input.distinctId featureFlags=input.featureFlags>
  <@title>Setup</@title>
  <@head>

    <!-- Tagify -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tagify/3.17.7/tagify.min.css" integrity="sha512-hqxNYuIWMQISqScYH0xQ3i8kH4MMxhJYlp7mfYvBGJKSGyliqk7SXRK3MxBuUnSwA1XeV+S+y3ad4oF+xD6kpA==" crossorigin="anonymous" media="print" onload="this.media='all'"/>
    <!-- Username Autocompletion Styling -->
    <style id="input-autocomplete-style">
            .ui-autocomplete {
                position: absolute;
                z-index: 9999999!important;
                max-height: 355px;
                overflow-y: auto;
                overflow-x: hidden;
                min-width: 160px;
                padding: 4px 0;
                margin: 10px 0 0 0;
                background-color: #fff;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                box-shadow: 0 1px 6px rgba(0,0,0,.06), 0 10px 15px rgba(0,0,0,.07);
                background: white;
                border: none;
                transition: opacity .16s ease-in-out;
                color: #a0aec0;
            }

            .autocomplete-followers, .autocomplete-username {
                margin: 0;
            }

            .ui-state-active {
                transition: all .4s;
            }

            .ui-menu-item a {
                background: #fff!important;
                border: none!important;
                border-bottom: 1px solid #eaeaea!important;
            }

            .autocomplete-username {
                color: #222;
                font-size: 15px;
                font-weight: 600;
            }

            .autocomplete-followers {
                color: #6b6b6b;
                font-weight: 500;
                letter-spacing: .6px;
            }

            /* <!-- Autocompletion Results Item --> */
            .kyb-suggest--user-link {
                display: block;
                padding: 10px 32px 10px 25px!important;
                text-align: left;
                text-decoration: none;
                overflow: hidden;
                position: relative;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
            }

            .kyb-suggest--user-link:hover {
                background-color: rgba(225,232,238,.4);
            }

            .kyb-suggest--user-link:after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 91px!important;
                right: 0;
                height: 1px;
                background: #eff3f6;
            }

            .kyb-suggest--user-link .icon.ni {
                position: absolute;
                top: 24px;
                right: 12px;
                font-size: 21px;
            }

            .kyb-suggest--user-followers:before {
                content: "";
                background: #bbcbd8;
                display: inline-block;
                vertical-align: middle;
                width: 6px;
                height: 6px;
                margin: 0 7px;
                border-radius: 50%;
            }

            .kyb-suggest-avatar {
                float: left;
                margin: 0 16px 0 0!important;
                width: 48px!important;
                height: 48px!important;
                border-radius: 50%;
                background: #eff3f6;
                border: 1px solid #e2e8f0;
                text-align: center;
                line-height: 46px;
                font-size: 18px;
            }

            .kyb-suggest--user-name {
                color: #434c5d;
                font-size: 16px;
                line-height: 24px;
                font-weight: 600;
                margin-top: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

                        /* <!-- Custom Input Field --> */

            .input__field:focus {
                outline: none;
                color: #535d92 !important;
            }

            .input__label {
                display: inline-block;
                float: right;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

            .input__label-content {
                position: relative;
                color: #fff;
                display: block;
                padding: 1.6em 0;
                width: 100%;
                padding-bottom: 0;
                margin-bottom: -20px;
            }
            tag.tagify__tag.tagify__tag_user {
                max-width: 530px;
            }
            tag.tagify__tag.tagify__tag_hashtag{
                max-width: 530px;
            }
            @media (max-width: 767.98px) {
                tag.tagify__tag.tagify__tag_hashtag {
                    max-width: 330px;
                }
                tag.tagify__tag.tagify__tag_user {
                    max-width: 330px;
                }
            }
        </style>
    <!-- General Setup Styling -->
    <style>
            .nk-split-content.nk-block-area.nk-block-area-column.nk-auth-container.bg-white {
                overflow: hidden;
            }

            .nk-auth-body, .nk-auth-footer {
                max-width: 820px;
            }

            .plan-card-wrapper {
                min-width: 269px;
            }

            .slider-wrap {
                padding: 0 40px !important;
            }
            .brand-logo, #alertContainer, #pageHeader, #loginForm, #accountPreview, .plansWrapper, .nk-block-head-sub , #targetForm, #freeSignUpForm, .term-con-sec{
                max-width: 540px !important;
                margin: 0 auto;
            }
            .term-con-sec{
                margin-top: 50px; 
                margin-bottom: 30px;
            }
            #freeSignUpForm{
                display:none;
            }
            .pricing {
                min-width: 249px !important;
            }
            
            #paymentFormWrapper, #connectAccountWrapper {
                max-width: 550px !important;
                margin: 0 auto;
            }

            .btn-group.select-option label .checkmark {
                display: block;
            }

            .checkmark svg {
                border: 1px solid #4238f2;
                border-radius: 50%;
            }

            .select-option label {
                color: #364963;
            }

            #proPlanOption.active {
                color: #4238f2 !important;
            }

            #proPlanOption.active .checkmark svg {
                fill: #4238f2 !important;
            }

            .btn-group.select-option label p.subtitle {
                font-size: 12px;
            }

            .analytic-data .amount {
                letter-spacing: -1px !important;
                font-size: 1.5rem !important;
                line-height: 1.2 !important;
            }

            .analytic-data .title {
                font-size: 14px !important;
            }

            .plansWrapper {
                margin-bottom: 4em;
            }

            #connectInstagramButton {
                background-color: #0a95f6;
                border-color: #0a95f6;
            }
            #connectInstagramButton:hover {
                background-color: #25a1f7;
                border-color: #25a1f7;
            }
            p#finalPlanDescription{
                margin-bottom: 0;
            }
            .insta-input{
                padding-left: 46px;
            }
            .tiktok-input{
                padding-left: 15px !important;
            }
            .btn-black{
                background: black !important;
            }
            #tik-logo{
                margin: -1px -10px 0px 0px;
            }
            .btn-dark-tiktok {
                background: #000000;
                color: white;
            }
            .btn-dark-tiktok:hover {
                color: white !important;
            }
            .exp-nk-block-middle {
                margin-top: 40px;
            }
            @media (max-width: 767.98px) {
                div .nk-block-title.page-title {
                    max-width: 100% !important;
                    font-size: 22px !important;
                }

                .nk-block-title em.icon.ni.ni-instagram {
                    font-size: 25px !important;
                }

                .analytic-data-group.analytic-ov-group {
                    justify-content: start;
                }

                #accountStatusAvatar .circle {
                    width: 80px !important;
                    height: 80px !important;
                }

                .analytic-data .amount {
                    color: #364A68 !important;
                    font-size: 1.4rem !important;
                    line-height: 1.2 !important;
                    margin-bottom: 0 !important;
                    letter-spacing: -1px !important;
                }

                .billingCycle {
                    max-width: 100% !important;
                    margin-top: 5px !important;
                }

                .billingCycle #annualOption {
                    padding: 19px 20px 15px 20px;
                }

                .billingCycle #monthlyOption {
                    padding: 20px 20px 18px 20px;
                }

                #annualPromo {
                    justify-content: center;
                }

                .plansWrapper {
                    margin-bottom: 2.5em;
                }

                .pricing-title {
                    margin: 2px 0 !important;
                }

                .pricing-body {
                    padding: 5px;
                }
                
                .planSelectButton {
                    height: 55px;
                }

                #planPageBackground {
                    bottom: -44% !important;
                }

                #buttonGradient {
                    top: -0.1rem !important;
                    right: 0rem !important;
                    bottom: -0.3rem !important;
                    left: -0.3rem !important;
                }

                .css-81wkxq {
                    padding: 1.4em !important;
                }

                #finalPlan {
                    font-size: 18px !important;
                }

                #finalPrice {
                    font-size: 17px !important;
                }

                #finalPlanDescription {
                    font-size: 14px !important;
                    line-height: 1.7 !important;
                }

                .analytic-data-group.analytic-ov-group {
                    justify-content: start !important;
                }

                #choosePlanTitle {
                    margin-bottom: 7px !important;
                }
                .weglot_switcher{
                    display:none !important;
                }
            }
        </style>
    </@head>
  <!-- <form action="/payment/createGooglePaySubscription" method="post">
            <div class="google-pay-button"></div>
        </form> -->
    <!-- <div id="timer-sec-setup" style="display: none;">
        <saletimer></saletimer>
    </div> -->
  <div class="nk-block-head" id="pageHeader">
    <div class="nk-block-head-content">
      <h4 class="nk-block-title" style="font-size: 25px;color: rgba(0, 0, 0, 0.8);margin-bottom: 10px;margin-top: 15px;display:flex;">
        <span id="spark-logo" style="display:none;">⚡</span> 
        <span id="tik-logo" style="display:none;">
            <img src="/images/tiktoklogo.png" alt="Loading animation image" style="width: 25px;margin-right: 15px;"/>
        </span> 
        Setup &  Start Growing
      </h4>
      <div class="nk-block-des " style="display: none;">
        <p style="font-size: 17px;line-height: 29px;font-weight: 400;color: rgb(24, 24, 24);">Let's finish your account setup and start your growth.</p>
      </div>
      <div id="nk-block-des-sale" class="nk-block-des-sale" style="display:none;">
        <p style="font-size: 17px;line-height: 29px;font-weight: 600;color: rgb(13 154 12);">50% off promo code is applied.</p>
      </div>
      <div id="nk-block-des-sale-new" class="nk-block-des-sale" style="display:none;">
        <p style="font-size: 17px;line-height: 29px;font-weight: 600;color: rgb(13 154 12);">50% off promo code is applied.</p>
      </div>
    </div>
  </div>
  <!-- .nk-block-head -->
  <flash-alert flash=out.stream.locals.flash/>
  <form id="loginForm" class="mt-2" novalidate>
    <div id="usernameInputWrapper" class="form-group">
      <div class="form-control-wrap form-group">
        <label id="insta-label" class="form-label" for="ig-username" style="font-size: 15px;margin-bottom: 8px;display: none;">Your Instagram Username</label>
        <label id="tiktok-label" class="form-label" for="ig-username" style="font-size: 15px;margin-bottom: 8px;display: none;">Your TikTok Handle</label>
        <div id="username_loading_icon" class="form-icon form-icon-right" style="display:none;right: 7px !important;transform: none;top: 39px;">
          <img src="/images/icons/loading.gif" alt="Loading animation image" style="width: 25px;margin-right: 15px;"/>
        </div>
        <div id="insta-logo" class="form-icon form-icon-left" style="left: 7px !important; z-index: 1; transform: none;top: 39px;">
          <em class="icon ni ni-instagram" style="font-size: 23px;"/>
        </div>
        <input type="text" dataType="user" class="autocomplete-input input__field form-control form-control-lg" id="ig-username" name="username" placeholder="" autofocus="true" autocomplete="new-password" style=""/>
      </div>
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input type="email" class="form-control  form-control-lg" name="email" id="email" placeholder="Enter your email address"/>
      </div>
    </div>
    <div class="form-group mb-2 mt-5">
      <div style="top: 0.1rem;right: -0.3rem;bottom: -0.3rem;left: -0.3rem;position: absolute;">
        <div class="linear-back" style="background: linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%);filter: blur(16px);opacity: 0.4;transform: rotate(180deg);width: 100%;height: 100%;"/>
      </div>
      <button id="connectAccountButton" class="btn btn-lg btn-block btn-block " type="submit" style="height: 54px;" data-callback="onSubmit" data-badge="bottomright">
        Continue <em class="icon ni ni-arrow-right" style="font-size: 19px;margin-left: 5px;"/>
      </button>
    </div>
    <div class="form-group" style="text-align:center">
      <!-- <p style="font-style: italic;color: var(--gray);font-size: 13px;">I agree to Plixi's <a tabindex="-1" href="/terms" alt="Plixi's Terms of Service" target="__blank" style="color:var(--primary);">Terms of Service</a></p> -->
    </div>
  </form>
  <form id="freeSignUpForm" class="mt-2" novalidate>
    <div id="usernameInputWrapper" class="form-group">
      <div class="form-control-wrap form-group">
        <label class="form-label" for="ig-username" style="font-size: 15px;margin-bottom: 8px;">Your Instagram Username</label>
        <div id="username_loading_icon" class="form-icon form-icon-right" style="display:none;right: 7px !important;transform: none;top: 39px;">
          <img src="/images/icons/loading.gif" alt="Loading animation image" style="width: 25px;margin-right: 15px;"/>
        </div>
        <div class="form-icon form-icon-left" style="left: 7px !important; z-index: 1; transform: none;top: 39px;">
          <em class="icon ni ni-instagram" style="font-size: 23px;"/>
        </div>
        <input type="text" dataType="user" class="autocomplete-input input__field form-control form-control-lg" id="ig-username-free" name="username" placeholder="selenagomez" autofocus="true" autocomplete="new-password" style="padding-left: 46px;"/>
      </div>
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input type="email" class="form-control  form-control-lg" name="email" id="emailFree" placeholder="Enter your email address"/>
      </div>
    </div>
    <div class="form-group mb-2 mt-5">
      <div style="top: 0.1rem;right: -0.3rem;bottom: -0.3rem;left: -0.3rem;position: absolute;">
        <div style="background: linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%);filter: blur(16px);opacity: 0.4;transform: rotate(180deg);width: 100%;height: 100%;"/>
      </div>
      <button id="FreeSignUpBtn" class="btn btn-lg btn-primary btn-block btn-block " type="submit" style="height: 54px;" data-callback="onSubmit" data-badge="bottomright">
        Continue <em class="icon ni ni-arrow-right" style="font-size: 19px;margin-left: 5px;"/>
      </button>
    </div>
    <div class="form-group" style="text-align:center">
      <!-- <p style="font-style: italic;color: var(--gray);font-size: 13px;">I agree to Plixi's <a tabindex="-1" href="/terms" alt="Plixi's Terms of Service" target="__blank" style="color:var(--primary);">Terms of Service</a></p> -->
    </div>
  </form>
  
  <@script>
    <script>
        const url1 = window.location.href;
        const pageValue2 = new URL(url1).searchParams.get("page");
        const pageValue3 = new URL(url1).searchParams.get("salePage");
        const pageValue4 = new URL(url1).searchParams.get("mirrorSite");
        const pageValue5 = new URL(url1).searchParams.get("mainSite");
        const pageValue6 = new URL(url1).searchParams.get("newPrice");
        const pageValue7 = new URL(url1).searchParams.get("tikTokGrowth");
        const attannualRaw = new URL(url1).searchParams.get("plan");
        const validPlans = ["basic", "pro", "experts", "lite", "basiclite", "prolite", "expertlite"];
        const attannual = (attannualRaw && validPlans.includes(String(attannualRaw).toLowerCase()))
            ? String(attannualRaw).toLowerCase()
            : ((localStorage.plan && validPlans.includes(String(localStorage.plan).toLowerCase()))
                ? String(localStorage.plan).toLowerCase()
                : "pro");
        const planperiodmain = new URL(url1).searchParams.get("yearly");
        let planperiod ;
        if (planperiodmain === "true"){
            planperiod = true;
            monthlyplanperiod = false;
        } else if (planperiodmain === "false") {
            planperiod = false;
            monthlyplanperiod = true;
        } else {
            // Bare /setup: honor explicit toggle, otherwise default annual
            if (localStorage.getItem("monthly") === "true") {
                planperiod = false;
                monthlyplanperiod = true;
            } else if (localStorage.getItem("yearly") === "true") {
                planperiod = true;
                monthlyplanperiod = false;
            } else if (localStorage.getItem("pricing_default") === "monthly") {
                planperiod = false;
                monthlyplanperiod = true;
            } else {
                planperiod = true;
                monthlyplanperiod = false;
            }
        }
        if(pageValue7){
            localStorage.setItem('tikTokGrowth', 'true');
        }
        if(pageValue6){
            if(planperiodmain === "true"){
                localStorage.setItem("fiftyperc",true);
            }
        }
        if(pageValue5){
            localStorage.setItem("pricing",true);
            localStorage.setItem("yearly",planperiod);
            localStorage.setItem("monthly",monthlyplanperiod);
            localStorage.setItem("plan",attannual);
            localStorage.setItem("toggle",monthlyplanperiod);
            if(pageValue6){
                localStorage.setItem("pathplan",pageValue6);
            }
        }
        if(pageValue4){
            localStorage.setItem("pricing",true);
            localStorage.setItem("yearly",planperiod);
            localStorage.setItem("monthly",monthlyplanperiod);
            localStorage.setItem("plan",attannual);
            localStorage.setItem("toggle",monthlyplanperiod);
            localStorage.setItem("showfiftyperc",true);
            if(pageValue6){
                localStorage.setItem("pathplan",pageValue6);
            }
        }
        if(pageValue3){
            localStorage.setItem("pricing",true);
            localStorage.setItem("yearly",true);
            localStorage.setItem("plan",attannual);
            localStorage.setItem("toggle",false);
            localStorage.setItem("flashSale",true);
        }
        if(pageValue2){
            localStorage.setItem("pricing",true);
        }
        // Direct setup links (?plan=&yearly=) — skip pricing redirect; promo is optional
        const hasDirectCheckoutParams =
            attannualRaw &&
            (planperiodmain === "true" || planperiodmain === "false");
        if (hasDirectCheckoutParams && !pageValue5 && !pageValue4 && !pageValue3) {
            localStorage.setItem("pricing", true);
            localStorage.setItem("yearly", planperiod ? "true" : "false");
            localStorage.setItem("monthly", monthlyplanperiod ? "true" : "false");
            localStorage.setItem("plan", attannual);
            localStorage.setItem("toggle", monthlyplanperiod ? "true" : "false");
            localStorage.setItem("pricing_default", planperiod ? "annual" : "monthly");
        }
        if(localStorage.pricing !== 'true'){
            // Preserve all query parameters when redirecting to pricing
            const urlParams = new URLSearchParams(window.location.search);
            const queryString = urlParams.toString();
            
            
            if(queryString && localStorage.tikTokGrowth == "true"){
                window.location.href = "${BASE_URL}/tiktok-growth/pricing" + `?${queryString}`;
            } else if(queryString && localStorage.tikTokGrowth == "false") {    
                window.location.href = "${BASE_URL}/pricing" + `?${queryString}`;
            } else {
                window.location.href = "${BASE_URL}/pricing";
            }
        }
        $(document).ready(function(){
            if(localStorage.tikTokGrowth === "true"){
                $("#tik-logo").attr("style", "display: block !important");
                $("#spark-logo").attr("style", "display: none !important");
                $("#tiktok-label").attr("style", "display: block !important");
                $("#insta-label").attr("style", "display: none !important");
                $("#insta-logo").attr("style", "display: none !important");
                $("#ig-username").attr("placeholder", "Enter Handle").addClass("tiktok-input");
                $("#connectAccountButton").addClass("btn-dark-tiktok");
                $("#connectAccountButton").removeClass("btn-primary");
                $(".linear-back").attr("style", "background: unset !important");
            }else{
                $("#tik-logo").attr("style", "display: none !important");
                $("#spark-logo").attr("style", "display: block !important");
                $("#tiktok-label").attr("style", "display: none !important");
                $("#insta-label").attr("style", "display: block !important");
                $("#ig-username").attr("placeholder", "selenagomez").removeClass("tiktok-input").addClass("insta-input");
                $("#connectAccountButton").addClass("btn-primary");
                $("#connectAccountButton").removeClass("btn-dark-tiktok");
                if ((localStorage.flashSale || (localStorage.yearly === "true")) && localStorage.freesignup !== "true" && localStorage.fiftyperc !== "true"){
                    $("#nk-block-des-sale").attr("style", "display: block !important");
                    $(".nk-block-des").attr("style", "display: none !important");
                    $("#nk-block-des-sale-new").attr("style", "display: none !important");
                } else if(localStorage.fiftyperc === "true" || localStorage.fiftyperc === true){
                    $("#nk-block-des-sale").attr("style", "display: none !important");
                    $(".nk-block-des").attr("style", "display: none !important");
                    $("#nk-block-des-sale-new").attr("style", "display: block !important");
                } else {
                    $("#nk-block-des-sale").attr("style", "display: none !important");
                    $(".nk-block-des").attr("style", "display: block !important");
                    $("#nk-block-des-sale-new").attr("style", "display: none !important");
                }
            }
            if(localStorage.username){
                $("#ig-username").val(localStorage.username);
            }
        });
    </script>
    <script>
        document.addEventListener('DOMContentLoaded', () => {
            const urlParams = new URLSearchParams(window.location.search);
            if (window.PlixiCheckoutPromo) {
                PlixiCheckoutPromo.captureInitialUrlPromo();
                const setupYearlyParam = urlParams.get('yearly');
                const setupIsAnnual = setupYearlyParam === 'true' || (setupYearlyParam !== 'false' && localStorage.getItem('monthly') !== 'true');
                PlixiCheckoutPromo.syncPromoToBillingCycle(setupIsAnnual);
                const setupPromo = PlixiCheckoutPromo.getPromo();
                if (setupPromo) {
                    const discountPercent = PlixiCheckoutPromo.getDiscountPercent(setupPromo);
                    $("#nk-block-des-sale p, #nk-block-des-sale-new p").text(discountPercent + '% off promo code is applied.');
                    $("#nk-block-des-sale").attr("style", "display: block !important");
                    $(".nk-block-des").attr("style", "display: none !important");
                    $("#nk-block-des-sale-new").attr("style", "display: none !important");
                }
            }
            if (window.plixiCheckoutAnalytics) {
                window.plixiCheckoutGateway = "${input.checkoutGateway || ''}";
                plixiCheckoutAnalytics.init({
                    gateway: "${input.checkoutGateway || ''}",
                    plan: localStorage.plan || null,
                    handle: localStorage.username || null,
                });
                // Identify only on Continue click (see form submit handler) — not while typing email
            }
            // Store addon from query params in localStorage
            const addonFromUrl = urlParams.get('addon');
            if (addonFromUrl) {
                localStorage.setItem('addon', addonFromUrl);
            }else{
                localStorage.removeItem('addon');
            }
            function setCookie(name, value) {
                document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${90 * 24 * 60 * 60}`;
            }
            function readCookie(name) {
                const prefix = name + '=';
                const parts = document.cookie.split(';');
                for (let i = 0; i < parts.length; i++) {
                    let part = parts[i];
                    while (part.charAt(0) === ' ') part = part.substring(1);
                    if (part.indexOf(prefix) === 0) {
                        return decodeURIComponent(part.substring(prefix.length));
                    }
                }
                return null;
            }
            const utmFields = [
                ['utm_source', urlParams.get('utm_source')],
                ['utm_campaign', urlParams.get('utm_campaign')],
                ['utm_medium', urlParams.get('utm_medium')],
                ['utm_term', urlParams.get('utm_term')],
                ['utm_content', urlParams.get('utm_content')],
            ];
            let capturedFromUrl = false;
            utmFields.forEach(function (entry) {
                const name = entry[0];
                const value = entry[1];
                if (value) {
                    setCookie(name, value);
                    capturedFromUrl = true;
                }
            });
            const hasStoredUtms = utmFields.some(function (entry) {
                return readCookie(entry[0]);
            });
            if (capturedFromUrl || hasStoredUtms) {
                localStorage.setItem('utmSet', 'true');
            }
        });
    </script>
    <script>
            if("${ENV}" === "production") {
                    fbq('track', 'PageView');
            }
            function numberWithCommas(x) {return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");}
            const searchParams = (new URL(window.location.href)).searchParams;
            if (searchParams)
                searchParams.forEach((x, y) => { 
                    if (y=='username') y='ig-username'
                    if (y && x && document.getElementById(y)) document.getElementById(y).value = x
                }) // Prepoluate fields with query data
            
          
            var username;
          
            
               const url = window.location.href;
               const pageValue = new URL(url).searchParams.get("page");
               if(pageValue){
                localStorage.setItem("freesignup",true);
               }
               if(localStorage.freesignup === "true"){
                localStorage.removeItem("yearly");
                localStorage.removeItem("monthly");
                localStorage.removeItem("flashSale")
                  $("#loginForm").hide();
                  $("#freeSignUpForm").show();
               } 
                else{
                  $("#loginForm").show(); 
                }
            var loadingPayment = false, paymentButtonAnimations=[], originalPaymentButtonText = $('button#payButton').text();   
            function setLoadingButton(isLoading) {
                loadingPayment = isLoading;
                const BUTTON_TRANSLATIONS = {
                    'en': ['Processing...', 'Verifying payment...', 'Almost there...'],
                    'ko': ['처리 중...', '결제 확인 중...', '거의 완료...'],
                    'es': ['Procesando...', 'Verificando pago...', 'Casi listo...'],
                    'ar': ['جاري المعالجة...', 'جاري التحقق من الدفع...', 'أوشكنا على الانتهاء...'],
                    'it': ['Elaborazione...', 'Verifica pagamento...', 'Quasi fatto...'],
                    'pt': ['Processando...', 'Verificando pagamento...', 'Quase pronto...'],
                    'fr': ['Traitement...', 'Vérification du paiement...', 'Presque fini...'],
                    'pl': ['Przetwarzanie...', 'Weryfikacja płatności...', 'Prawie gotowe...'],
                    'de': ['Verarbeitung...', 'Zahlung wird überprüft...', 'Fast fertig...']
                };
                const currentLang = Weglot.getCurrentLang();
                const buttonStates = BUTTON_TRANSLATIONS[currentLang] || BUTTON_TRANSLATIONS['en'];

                $('button#payButton').prop("disabled", isLoading);
                if (isLoading){
                    $("#paymentModalCloseButton").hide()
                    for (var i=0; i<buttonStates.length; i++){
                        const buttonText = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span>' + buttonStates[i] + '</span>'
                        paymentButtonAnimations[i] = setTimeout(() => { $('button#payButton').html(buttonText);}, 3200 * i);
                    }
                }else {
                    $("#paymentModalCloseButton").show()
                    for (var i=0; i<paymentButtonAnimations.length; i++)
                        clearTimeout(paymentButtonAnimations[i])
                    $('button#payButton').html(`<span>${originalPaymentButtonText}</span><em class="icon ni ni-arrow-right"></em>`);
                }
            }
            var buttonAnimations=[];
            
            // Translation object for button states
            var buttonTranslations = {
                'en': {
                    'loadingAccount': 'Loading account...',
                    'analyzingAccount': 'Analyzing account...',
                    'fetchingAccount': 'Fetching account...',
                    'loading': 'Loading...',
                    'continue': 'Continue',
                    'startGrowth': 'Start Your Growth',
                    'usernameRequired': 'Please enter your Instagram username before continuing.',
                    'tiktokUsernameRequired': 'Please enter your TikTok username before continuing.',
                    'emailRequired': 'Please enter your email address before continuing.',
                    'emailInvalid': 'Please enter a valid email address.'
                },
                'es': {
                    'loadingAccount': 'Cargando cuenta...',
                    'analyzingAccount': 'Analizando cuenta...',
                    'fetchingAccount': 'Obteniendo cuenta...',
                    'loading': 'Cargando...',
                    'continue': 'Continuar',
                    'startGrowth': 'Inicia Tu Crecimiento',
                    'usernameRequired': 'Por favor, ingresa tu nombre de usuario de Instagram antes de continuar.',
                    'tiktokUsernameRequired': 'Por favor, ingresa tu nombre de usuario de TikTok antes de continuar.',
                    'emailRequired': 'Por favor, ingresa tu dirección de correo electrónico antes de continuar.',
                    'emailInvalid': 'Por favor, ingresa una dirección de correo electrónico válida.'
                },
                'fr': {
                    'loadingAccount': 'Chargement du compte...',
                    'analyzingAccount': 'Analyse du compte...',
                    'fetchingAccount': 'Récupération du compte...',
                    'loading': 'Chargement...',
                    'continue': 'Continuer',
                    'startGrowth': 'Commencez Votre Croissance',
                    'usernameRequired': 'Veuillez entrer votre nom d utilisateur Instagram avant de continuer.',
                    'tiktokUsernameRequired': 'Veuillez entrer votre nom d utilisateur TikTok avant de continuer.',
                    'emailRequired': 'Veuillez entrer votre adresse e-mail avant de continuer.',
                    'emailInvalid': 'Veuillez entrer une adresse e-mail valide.'
                },
                'de': {
                    'loadingAccount': 'Konto wird geladen...',
                    'analyzingAccount': 'Konto wird analysiert...',
                    'fetchingAccount': 'Konto wird abgerufen...',
                    'loading': 'Wird geladen...',
                    'continue': 'Weiter',
                    'startGrowth': 'Starten Sie Ihr Wachstum',
                    'usernameRequired': 'Bitte geben Sie Ihren Instagram-Benutzernamen ein, bevor Sie fortfahren.',
                    'tiktokUsernameRequired': 'Bitte geben Sie Ihren TikTok-Benutzernamen ein, bevor Sie fortfahren.',
                    'emailRequired': 'Bitte geben Sie Ihre E-Mail-Adresse ein, bevor Sie fortfahren.',
                    'emailInvalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
                },
                'it': {
                    'loadingAccount': 'Caricamento account...',
                    'analyzingAccount': 'Analisi account...',
                    'fetchingAccount': 'Recupero account...',
                    'loading': 'Caricamento...',
                    'continue': 'Continua',
                    'startGrowth': 'Inizia La Tua Crescita',
                    'usernameRequired': 'Inserisci il tuo nome utente Instagram prima di continuare.',
                    'tiktokUsernameRequired': 'Inserisci il tuo nome utente TikTok prima di continuare.',
                    'emailRequired': 'Inserisci il tuo indirizzo email prima di continuare.',
                    'emailInvalid': 'Inserisci un indirizzo email valido.'
                },
                'pt': {
                    'loadingAccount': 'Carregando conta...',
                    'analyzingAccount': 'Analisando conta...',
                    'fetchingAccount': 'Buscando conta...',
                    'loading': 'Carregando...',
                    'continue': 'Continuar',
                    'startGrowth': 'Inicie Seu Crescimento',
                    'usernameRequired': 'Por favor, insira seu nome de usuário do Instagram antes de continuar.',
                    'tiktokUsernameRequired': 'Por favor, insira seu nome de usuário do TikTok antes de continuar.',
                    'emailRequired': 'Por favor, insira seu endereço de e-mail antes de continuar.',
                    'emailInvalid': 'Por favor, insira um endereço de e-mail válido.'
                },
                'ko': {
                    'loadingAccount': '계정 로딩 중...',
                    'analyzingAccount': '계정 분석 중...',
                    'fetchingAccount': '계정 가져오는 중...',
                    'loading': '로딩 중...',
                    'continue': '계속',
                    'startGrowth': '성장 시작하기',
                    'usernameRequired': '계속하기 전에 Instagram 사용자 이름을 입력해 주세요.',
                    'tiktokUsernameRequired': '계속하기 전에 TikTok 사용자 이름을 입력해 주세요.',
                    'emailRequired': '계속하기 전에 이메일 주소를 입력해 주세요.',
                    'emailInvalid': '유효한 이메일 주소를 입력해 주세요.'
                }
            };
            
            // Function to get current language
            function getCurrentLanguage() {
                if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang) {
                    return Weglot.getCurrentLang();
                }
                // Fallback to detecting from URL or other methods
                var lang = document.documentElement.lang || 'en';
                return lang.split('-')[0]; // Get language code without country
            }
            
            // Function to get translated text
            function getTranslatedText(key) {
                var currentLang = getCurrentLanguage();
                var translations = buttonTranslations[currentLang] || buttonTranslations['en'];
                return translations[key] || buttonTranslations['en'][key];
            }
            
             function setUsernameLoadingButton(isLoading) {
        var buttonStates = [
            getTranslatedText('loadingAccount'),
            getTranslatedText('analyzingAccount'),
            getTranslatedText('fetchingAccount'),
            getTranslatedText('loading')
        ];
        $('#connectAccountButton').prop("disabled", isLoading);
        $('#FreeSignUpBtn').prop("disabled", isLoading);
        $("input#ig-username").prop('disabled', isLoading);
        $("#addAccountForm :input").each(function () {
            $(this).prop("readonly", isLoading);
        });
        if (isLoading) {
            for (var i = 0; i < buttonStates.length; i++) {
                const buttonText = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span>' + buttonStates[i] + '</span>';
                buttonAnimations.push(setTimeout(() => {
                    $('#connectAccountButton').html(buttonText);
                    $('#FreeSignUpBtn').html(buttonText);
                }, 3200 * i));
            }
        } else {
            for (var i = 0; i < buttonAnimations.length; i++) {
                clearTimeout(buttonAnimations[i]);
            }
            buttonAnimations = []; // Clearing all the button animations
            $('#connectAccountButton').html('<span>' + getTranslatedText('continue') + '</span><em class="icon ni ni-arrow-right"></em>');
            $('#FreeSignUpBtn').html('<span>' + getTranslatedText('startGrowth') + '</span><em class="icon ni ni-arrow-right"></em>');
            $("input#ig-username").prop('disabled', false);
        }
    }

            function validURL(str) {
                try {
                    new URL(str);
                    return true;
                } catch (e) {
                    return false;
                }
            }
            function extractUsername(value) {
                var username = '';
                // Detect TikTok or Instagram
                const isInsta = /(instagram\.com|instagr\.am)/i.test(value);
                const isTikTok = /(tiktok\.com)/i.test(value);
                // When value is URL
                if (validURL(value)) {
                    // Instagram URL
                    if (isInsta) {
                        const rx = /(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)/im;
                        let match = rx.exec(value);
                        username = match ? match[1] : value.replace(/\//g, '');
                    }
                    // TikTok URL
                    else if (isTikTok) {
                        // Supports both /@username and /username
                        const rx = /tiktok\.com\/(?:@)?([A-Za-z0-9._]+)/i;
                        let match = rx.exec(value);
                        username = match ? match[1] : value.replace(/\//g, '');
                    }
                    else {
                        username = value.replace(/\//g, '');
                    }

                } 
                // When value is NOT URL
                else {
                    // Instagram username formats
                    if (isInsta) {
                        const rx = /^(?:@|(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/)?(\w.+)\/?$/;
                        let match = rx.exec(value);
                        username = match ? match[1] : value.replace(/\//g, '');
                    }
                    // TikTok username formats
                    else if (isTikTok || value.startsWith("@")) {
                        // TikTok usernames allow letters, numbers, underscore, dot
                        const rx = /^@?([A-Za-z0-9._]+)$/;
                        let match = rx.exec(value);
                        username = match ? match[1] : value.replace(/\//g, '');
                    }
                    else {
                        username = value.replace(/\//g, '');
                    }
                }
                return username.trim().toLowerCase();
            }
            $("#loginForm").submit(function(e) {
                e.preventDefault();
                
                // Validation
                var usernameInput = $('#ig-username').val().trim();
                var emailInput = $('#email').val().trim();
                
                // Validate username
                if (!usernameInput) {
                    var usernameErrorKey = localStorage.tikTokGrowth === 'true' ? 'tiktokUsernameRequired' : 'usernameRequired';
                    ShowAlert('error', getTranslatedText(usernameErrorKey));
                    return;
                }
                
                // Validate email
                if (!emailInput) {
                    ShowAlert('error', getTranslatedText('emailRequired'));
                    return;
                }
                
                // Validate email format
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(emailInput)) {
                    ShowAlert('error', getTranslatedText('emailInvalid'));
                    return;
                }
                
                // Hide any existing alerts before proceeding
                $('#alertContainer').hide();
                
                username = extractUsername($('#ig-username').val());
                // username = $('#ig-username').val().toLowerCase().replace(/ /g, '');
                if (username.charAt(0) == '@') username = username.substr(1);
                captureUsernameEntered(username);
                document.activeElement.blur();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                setUsernameLoadingButton(true);
                $.ajax({
                    type: "GET",
                    url: `/instagram-profile/${username}`,
                    data: $("#addAccountForm").serialize(),
                    statusCode: {
                        200: function(response) {
                            setUsernameLoadingButton(false);
                            // $('.instagramAvatar').each(function () { $(this).attr('src', response.graphql.user.profile_pic_url);});
                            // $('.instagramUsername').each(function() { $(this).text(response.graphql.user.username);});
                            // $('#instagramFollowersCount').text(numberWithCommas(response.graphql.user.edge_followed_by.count));
                            // $('#instagramGrowthCount').html(`${numberWithCommas(response.graphql.user.edge_followed_by.count+3351)} <em class="icon ni ni-chevron-up-circle-fill" style="margin-left: 5px;"></em>`);
                            // $('#instagramFollowingsCount').text(numberWithCommas(response.graphql.user.edge_follow.count));
                            // $('#instagramPostCount').text(numberWithCommas(response.graphql.user.edge_owner_to_timeline_media.count));
                        },
                    },
                });
                var checkemailData = {
                    email: $('#email').val()
                    };
                    var apiUrl = "/checkemail";
                    $.ajax({
                    type: "POST",
                    url: apiUrl,
                    data: checkemailData,
                    success: function(response) {
                        if(response.error){
                            ShowAlert('error', "This email address has already been used. ");
                            setUsernameLoadingButton(false);
                        }
                        else{
                            localStorage.setItem("email",$('#email').val())
                            localStorage.setItem("username",username)
                            if (window.plixiCheckoutAnalytics) {
                                plixiCheckoutAnalytics.identifyUser($('#email').val(), { handle: username });
                            }
                            if (window.location.hostname == 'plixi.com' && cc) {
                                ttq.instance('CKOL473C77UDR4OGTP70').track('Add To Cart');
                            }
                            if (window.PlixiCheckoutPromo) {
                                PlixiCheckoutPromo.syncFromUrl();
                            }
                            window.location.replace(
                                window.PlixiCheckoutPromo
                                    ? PlixiCheckoutPromo.buildPaymentUrl('${BASE_URL}/payment')
                                    : '${BASE_URL}/payment'
                            );
                        }
                    }
                })
                    
            });
             $("#freeSignUpForm").submit(function(e) {
                e.preventDefault();
                
                // Validation
                var usernameInput = $('#ig-username-free').val().trim();
                var emailInput = $('#emailFree').val().trim();
                
                // Validate username
                if (!usernameInput) {
                    var usernameErrorKey = localStorage.tikTokGrowth === 'true' ? 'tiktokUsernameRequired' : 'usernameRequired';
                    ShowAlert('error', getTranslatedText(usernameErrorKey));
                    return;
                }
                
                // Validate email
                if (!emailInput) {
                    ShowAlert('error', getTranslatedText('emailRequired'));
                    return;
                }
                
                // Validate email format
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(emailInput)) {
                    ShowAlert('error', getTranslatedText('emailInvalid'));
                    return;
                }
                
                // Hide any existing alerts before proceeding
                $('#alertContainer').hide();
                
                username = extractUsername($('#ig-username-free').val());
                // username = $('#ig-username').val().toLowerCase().replace(/ /g, '');
                if (username.charAt(0) == '@') username = username.substr(1);
                captureUsernameEntered(username);
                document.activeElement.blur();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                setUsernameLoadingButton(true);
                $.ajax({
                    type: "GET",
                    url: `/instagram-profile/${username}`,
                    data: $("#freeSignUpForm").serialize(),
                    statusCode: {
                        200: function(response) {
                            setUsernameLoadingButton(false);
                            $('.instagramAvatar').each(function () { $(this).attr('src', response.graphql.user.profile_pic_url)});
                            $('.instagramUsername').each(function() { $(this).text(response.graphql.user.username);});
                            $('#instagramFollowersCount').text(numberWithCommas(response.graphql.user.edge_followed_by.count));
                            $('#instagramGrowthCount').html(`${numberWithCommas(response.graphql.user.edge_followed_by.count+3351)} <em class="icon ni ni-chevron-up-circle-fill" style="margin-left: 5px;"></em>`);
                            $('#instagramFollowingsCount').text(numberWithCommas(response.graphql.user.edge_follow.count));
                            $('#instagramPostCount').text(numberWithCommas(response.graphql.user.edge_owner_to_timeline_media.count));
                        },
                    },
                });
                var freeSerializedData = {
                        name:"test",
                        email: $('#emailFree').val(), 
                        password: "12345678",
                        username:$('#ig-username-free').val().toLowerCase().replace(/ /g, ''),
                        freeSignUp:true
                    };
                var checkemailData = {
                    email: $('#emailFree').val()
                    };
                var apiUrl = "/checkemail";
                    $.ajax({
                    type: "POST",
                    url: apiUrl,
                    data: checkemailData,
                    success: function(response) {
                        if(response.error){
                        ShowAlert('error', "This email address has already been used. ");
                        setUsernameLoadingButton(false);
                        }
                        else{
                            $.ajax({
                                type: "POST",
                                url: "/setup",
                                data: freeSerializedData,
                                success: function(response) {
                                    if(response.error){
                                    ShowAlert('error', response.error);
                                    }
                                    else{
                                    const user_id = response.user_id;
                                    localStorage.setItem("chargeParams" , true);
                                    window.location.href = '${BASE_URL}/2/success';
                                    }
                                }
                            })
                        }
                    }
                })  
            });
             

            var alertTimeout;
            function ShowAlert(msg_type, msg_body, msg_title) {
                var AlertMsg = $('#alertContainer')
                var alertClass = 'info', alertIcon = 'alert-circle';
                if (msg_type == 'error') {
                    alertClass = "danger";
                    
                }else if (msg_type == 'success') {
                    alertClass = "success";
                    
                }
                if (msg_title) $(AlertMsg).find('strong').html(msg_title);
                $(AlertMsg).find('span').html(msg_body);
                $(AlertMsg).removeAttr('class');
                $(AlertMsg).addClass('alert alert-fill alert-dismissible alert-' + alertClass);
                $(AlertMsg).show();
                $('#alertContainer').on('close.bs.alert', function (e) {e.preventDefault();$(this).hide();});
                setLoadingButton(false);
                window.scrollTo({top: 0, behavior: 'smooth'});
                
                // Auto-hide alert after 5 seconds
                if (alertTimeout) clearTimeout(alertTimeout);
                alertTimeout = setTimeout(function() {
                    $(AlertMsg).fadeOut(300);
                }, 5000);
            }
        </script>
        <!-- Username Autocomplete -->
        <script id="input-autocomplete-script">
            function defer(method) {if (window.jQuery)method();else setTimeout(function() { defer(method) }, 50);}
            var cache = {user:{}}, usernameTagify, selectedSuggestion;
            var usernameEnteredTimeout = null;
            var lastUsernameEnteredCapture = '';

            function captureUsernameEntered(username) {
                var term = (username || '').trim().toLowerCase();
                if (term.length < 4) return;
                if (term === lastUsernameEnteredCapture) return;
                if (typeof posthog === 'undefined' || !posthog.capture) return;

                lastUsernameEnteredCapture = term;
                posthog.capture('username_entered', {
                    username: term,
                    origin: 'client'
                });
            }

            function scheduleUsernameEnteredCapture(username) {
                if (usernameEnteredTimeout) clearTimeout(usernameEnteredTimeout);
                usernameEnteredTimeout = setTimeout(function() {
                    captureUsernameEntered(username);
                }, 1000);
            }

            defer(function () {
                $.getScript("https://code.jquery.com/ui/1.12.1/jquery-ui.js", function(){
                    $('.autocomplete-input').each(function(){
                        $(this).on('input', function() {
                            scheduleUsernameEnteredCapture($(this).val());
                        });
                        $(this).focus(function() {
                            // Scroll to field on mobile
                            if (/sm|xs/.test(getBootstrapBreakpoint())) {
                                $([document.documentElement, document.body]).animate({ scrollTop: $(this).offset().top-75 }, 500);
                            }
                            // Show autocomplete window on focus
                            if ($(this).val())
                                $(this).autocomplete("search", $(this).val())
                        });

                        var isSearching = null;
                        $(this).autocomplete({
                            minLength: 4,
                            position: { my: "left top+10" },
                            source: function(request, response) {
                                var term = request.term;
                                if (term == selectedSuggestion){ 
                                    return false;
                                }
                                if (cache['user'] && term in cache['user']) {
                                    response(cache['user'][term]);
                                    return;
                                }
                                if (isSearching) clearTimeout(isSearching);
                                

                                isSearching = setTimeout(() => {
                                    $("#username_loading_icon").show();
                                    const isTiktok = localStorage.getItem('tikTokGrowth') === 'true'
                                    var url = isTiktok ? `/suggest?search=${term}&tiktok=true`: `/suggest?search=${term}&tiktok=false`;
                                    $.getJSON(url, {}, function(data, status, xhr) {
                                        var results;
                                        results = data.list.map(function(el){return {label: el.username, value: el}})
                                        cache['user'][term] = results;
                                        $('#ui-id-1').scrollTop(0);
                                        $("#username_loading_icon").hide();
    
                                        if (!results.length) {
                                            $('#ig-username').addClass('error');
                                        }
    
                                        return response(results);
                                    });
                                }, 2000);

                            },
                            focus: function(e, ui) {
                                e.preventDefault();
                                // $(this).val(ui.item.value.username);
                            },
                            select: function(e, ui) {
                                e.preventDefault();
                                $("#username_loading_icon").hide();
                                $(this).val(ui.item.value.username);
                                selectedSuggestion = ui.item.value.username;
                                captureUsernameEntered(ui.item.value.username);

                                $(this).blur()
                                return false;
                            }
                        });
                        $(this).data("ui-autocomplete")._renderItem = function(ul, item) {

                            if (!ul) {
                                console.error("Autocomplete 'ul' element is undefined. Ensure Autocomplete is initialized properly.");
                                return null; // Stop if no UL element
                            } 
                            // Fix for IG image links – use Google translate API
                            var t = (item.value && item.value.profile_pic_url) ? item.value.profile_pic_url : '';
                            var $item;
                            $item = $(`
                                    <div class="kyb-suggest--user-link" aria-label="${item.value.username}" data-value="${item.value.username}">
                                        <img class="kyb-suggest-avatar" src="${t || 'https://plixi.com/img/icons/default-avatar.png'}" alt="" referrerpolicy="no-referrer" onerror="this.onerror=null;this.src='https://plixi.com/img/icons/default-avatar.png'">
                                        <div class="kyb-suggest--user-name" data-wg-notranslate>${item.value.username} ${item.value.is_verified ? '<img src="https://cdn.plixi.com/images/icons/verified-icon.png?auto=format,compress" width="15px" alt="Verified" loading="lazy"/>':''}</div>
                                        ${item.value.full_name}
                                        ${item.value.followers_count ? `<span class="kyb-suggest--user-followers">${nFormatter(item.value.followers_count,1)} followers</span>` : ''}
                                        <em class="icon ni ni-chevron-right"></em></i>
                                    </div>
                            `)
                            
                            return $item.appendTo(ul)
                        };
                    });
                    $(window).resize(function() { $(".ui-autocomplete").css('display', 'none'); });
                });
            });
        </script>
        <!-- <script>
            document.addEventListener("DOMContentLoaded", function () {
                let saleTimer = localStorage.getItem("saleTimer");
                if(!saleTimer){
                    posthog.onFeatureFlags(function() {
                        saleTimer = posthog.getFeatureFlag('sale-countdown')
                        if (saleTimer === 'countdown-timer') {
                            localStorage.setItem("saleTimer", saleTimer);
                            document.getElementById('timer-sec-setup').style.display = 'block';
                        } else {
                            localStorage.setItem("saleTimer", saleTimer);
                            document.getElementById('timer-sec-setup').style.display = 'none';
                        }
                    })
                }
            });
        </script> -->
  </@script>
</preauth_layout>
